// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"e0eb84cf","774":"e0eb84cf"}[chunkId] + ".chunk.css";
};